/**
 * The filters in force, as chips (#2290): one per settled filter token, in
 * the box's order. Tapping a chip opens its field in the Filters panel; its
 * ✕ removes it from the search. "Clear all" removes every filter and keeps
 * the words.
 */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { chipText, type Field, type Token } from './searchSyntax';
import './discoverSearch.css';

interface Props {
  chips: Token[];
  onEdit: (field: Field) => void;
  onRemove: (t: Token) => void;
  onClearAll: () => void;
  className?: string;
}

export default function SearchChips({ chips, onEdit, onRemove, onClearAll, className = '' }: Readonly<Props>) {
  if (!chips.length) return null;
  return (
    <div // NOSONAR typescript:S6819 accessibility-by-design: group of commands, not form controls: the active filters, each an Edit and a Remove command, not a form-control group, so not a <fieldset>; and not a disclosure, so not a <details>
      className={`dsq-chips ${className}`}
      role="group"
      aria-label="Active filters"
    >
      {chips.map((t) => {
        const words = chipText(t);
        return (
          <span key={`${t.start}:${t.group ?? ''}`} className={`dsq-chip dsq-k-${t.kind}`} title={t.raw}>
            <button
              type="button"
              className="dsq-chip-body"
              aria-label={`Edit filter ${words}`}
              onClick={() => t.field && onEdit(t.field)}
            >
              <span className="dsq-chip-name">{t.chip?.name}</span>
              {t.chip?.value && <span className="dsq-chip-value">{t.chip.value}</span>}
            </button>
            <button
              type="button"
              className="dsq-chip-x"
              aria-label={`Remove filter ${words}`}
              onClick={() => onRemove(t)}
            >
              <FontAwesomeIcon icon={faXmark}/>
            </button>
          </span>
        );
      })}
      <button type="button" className="dsq-link" onClick={onClearAll}>Clear all</button>
    </div>
  );
}
